export default "__VITE_ASSET__Df8_Olzy__"